import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import Home from "./pages/Home";
import About from "./pages/About";
import Programs from "./pages/Programs";
import Donate from "./pages/Donate";
import Volunteer from "./pages/Volunteer";
import Contact from "./pages/Contact";
import News from "./pages/News";
import NewsArticle from "./pages/NewsArticle";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import AdminPrograms from "./pages/AdminPrograms";
import AdminNews from "./pages/AdminNews";
import AdminTeam from "./pages/AdminTeam";
import AdminEvents from "./pages/AdminEvents";
import AdminSubmissions from "./pages/AdminSubmissions";
import AdminOrganization from "./pages/AdminOrganization";
import AdminDonations from "./pages/AdminDonations";
import AdminGallery from "./pages/AdminGallery";
import AdminVolunteerOpportunities from "./pages/AdminVolunteerOpportunities";
import Gallery from "./pages/Gallery";
import GalleryEvent from "./pages/GalleryEvent";
import Events from "./pages/Events";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          {/* Public Routes with Header/Footer */}
          <Route path="/" element={
            <>
              <Header />
              <main><Home /></main>
              <Footer />
            </>
          } />
          <Route path="/about" element={
            <>
              <Header />
              <main><About /></main>
              <Footer />
            </>
          } />
          <Route path="/programs" element={
            <>
              <Header />
              <main><Programs /></main>
              <Footer />
            </>
          } />
          <Route path="/donate" element={
            <>
              <Header />
              <main><Donate /></main>
              <Footer />
            </>
          } />
          <Route path="/volunteer" element={
            <>
              <Header />
              <main><Volunteer /></main>
              <Footer />
            </>
          } />
          <Route path="/contact" element={
            <>
              <Header />
              <main><Contact /></main>
              <Footer />
            </>
          } />
          <Route path="/news" element={
            <>
              <Header />
              <main><News /></main>
              <Footer />
            </>
          } />
          <Route path="/news/:id" element={
            <>
              <Header />
              <main><NewsArticle /></main>
              <Footer />
            </>
          } />
          <Route path="/gallery" element={
            <>
              <Header />
              <main><Gallery /></main>
              <Footer />
            </>
          } />
          <Route path="/gallery/:slug" element={
            <>
              <Header />
              <main><GalleryEvent /></main>
              <Footer />
            </>
          } />
          <Route path="/events" element={
            <>
              <Header />
              <main><Events /></main>
              <Footer />
            </>
          } />
          
          {/* Admin Routes without Header/Footer */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/admin/programs" element={<AdminPrograms />} />
          <Route path="/admin/news" element={<AdminNews />} />
          <Route path="/admin/team" element={<AdminTeam />} />
          <Route path="/admin/events" element={<AdminEvents />} />
          <Route path="/admin/submissions" element={<AdminSubmissions />} />
          <Route path="/admin/organization" element={<AdminOrganization />} />
          <Route path="/admin/donations" element={<AdminDonations />} />
          <Route path="/admin/gallery" element={<AdminGallery />} />
          <Route path="/admin/volunteer-opportunities" element={<AdminVolunteerOpportunities />} />
        </Routes>
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
